export const ru = {
    'error-display-conditions': 'Произошла ошибка, попробуйте еще раз',
    'fetch-moderation-reject-reasons-error': 'Не удалось получить причины отклонения. Попробуйте еще раз',
    'many-image-can-load': 'В эту группу можно загрузить только {count} изображений',
    'not-loaded-files-button': 'Ок',
    'not-loaded-files-title': 'Следующие файлы не были загружены',
    'one-image-can-load': 'В эту группу можно загрузить только одно изображение',
    'some-image-can-load': 'В эту группу можно загрузить только {count} изображения',
    'warning-about-changes': 'Изменения не будут сохранены, продолжить?'
};
